import { render } from "./EarlierResearchRow.vue?vue&type=template&id=38f2143b&scoped=true"
import script from "./EarlierResearchRow.vue?vue&type=script&lang=js"
export * from "./EarlierResearchRow.vue?vue&type=script&lang=js"

import "./EarlierResearchRow.vue?vue&type=style&index=0&id=38f2143b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f2143b"]])

export default __exports__